import { createSlice } from '@reduxjs/toolkit';

const defaultState = {
    error: [],
    invalidOAuth: null,
};

const { actions, reducer } = createSlice({
    name: 'errorHandler',
    initialState: defaultState,
    reducers: {
        setError: (state, action) => {
            const { data } = action.payload;

            if (!state.error.find(err => err.code === data.code && err.message === data.message)) {
                let message;
                if (data.errorResponse) {
                    message = data.message.substr(0, data.message.indexOf(' ('));
                } else {
                    message = data.message;
                }
                state.error.push({
                    ...data,
                    message: message,
                });
            }
        },
        deleteError: (state, action) => {
            const { index } = action.payload;
            state.error.splice(index, 1);
        },
        setErrInvalidOauth: (state, action) => {
            state.initialState = action.payload;
        },
    },
});

export const { setError, deleteError } = actions;
export default reducer;
